export function generateNumericalString(codeLength) {
  return String(
    (Math.random() * (9 * (10**codeLength)) + (10**codeLength)) // generate a random number between 1EcodeLength and 10EcodeLength.
  ).substring(1, codeLength+1); // take a substring of codeLength, starting after the 1st digit to allow the possibility of it starting with 0                                                                          
}

export function allCharsSame(code) {
  let result = true;
  
  code = String(code);
  const firstChar = code.charAt(0);
  for (let i = 1; i < code.length; i++) {
    if (code.charAt(i) !== firstChar) {
      result = false;
      break;
    }
  }
  return result;                                                                    
}

export function generateNumericalStringNotAllSame(codeLength) {
  let generatedCode = generateNumericalString(codeLength);

  while (allCharsSame(String(generatedCode))) {
    generatedCode = generateNumericalString(codeLength);
  }
  return generatedCode;
}